import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/nav/Navbar';
import HeroSection from '../components/home/HeroSection';
import ArtistGrid from '../components/home/ArtistGrid';
import LatestReleases from '../components/home/LatestReleases';
import LoadingScreen from '../components/common/LoadingScreen';
import Footer from '../components/nav/Footer';
import { useHome } from '../hooks/useHome';

const Home = () => {
  const { featuredArtists, latestReleases, loading } = useHome();

  if (loading) return <LoadingScreen message="Loading..." />;

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex flex-col">
      <Navbar />
      <HeroSection featuredArtist={featuredArtists[0]} />

      {/* Featured Artists */}
      <section className="max-w-7xl mx-auto px-8 py-24 space-y-12 relative z-10 w-full">
        <div className="flex items-end justify-between border-b border-white/10 pb-8">
          <div className="space-y-2">
            <span className="text-xs font-black tracking-widest text-brand-pink uppercase">Verified Creators</span>
            <h2 className="text-5xl font-black tracking-tighter text-white uppercase">Featured Artists</h2>
          </div>
          <Link to="/auth" className="text-xs font-black tracking-widest text-zinc-400 hover:text-brand-coral transition-colors uppercase pb-1">
            Join as Artist →
          </Link>
        </div>
        <ArtistGrid artists={featuredArtists} />
      </section>

      {/* Latest Releases + CTA */}
      <section className="max-w-7xl mx-auto px-8 py-24 space-y-12 border-t border-white/10 relative z-10 w-full mb-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          <div className="space-y-8">
            <div className="space-y-2">
              <span className="text-xs font-black tracking-widest text-zinc-500 uppercase">Fresh Drops</span>
              <h2 className="text-5xl font-black tracking-tighter text-white uppercase">Latest Releases</h2>
            </div>
            <LatestReleases releases={latestReleases} />
          </div>

          <div className="space-y-6">
            <div className="space-y-2">
              <span className="text-xs font-black tracking-widest text-zinc-500 uppercase">For Creators</span>
              <h2 className="text-5xl font-black tracking-tighter text-white uppercase">Your Portal Awaits</h2>
            </div>
            <p className="text-zinc-300 text-lg font-bold leading-relaxed">
              Artists and labels get a dedicated portal to publish exclusive content, manage releases, and receive direct payments from fans.
            </p>
            <div className="space-y-4 pt-4">
              {[
                { label: 'Artist Portal', desc: 'Publish music & collect direct support', to: '/auth' },
                { label: 'Label Portal', desc: 'Manage your roster & releases', to: '/auth' },
              ].map(item => (
                <Link key={item.label} to={item.to}
                  className="flex items-center justify-between p-6 glass-card rounded-2xl group">
                  <div>
                    <p className="font-black uppercase tracking-tight text-white">{item.label}</p>
                    <p className="text-zinc-400 text-xs font-bold mt-1">{item.desc}</p>
                  </div>
                  <span className="text-zinc-600 group-hover:text-brand-pink transition-colors font-black">→</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;